// extracted by mini-css-extract-plugin
export default {"banner":"dnP4g","banner__container":"Bqe9J","banner__content":"Gg9AV","banner__legal":"mBgiq","banner__image":"w7Ftq"};